
import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { ObjectManager } from '../../../concepts/objects/ObjectManager';
import { EditorOptions } from '../../canvas/EditorOptions';
import { ActiveObject, resolve } from '../../Container';
import { Comment } from './Comment';
import { commentsOpen } from './CommentCommands';

export class AutoOpenCommentWidgetMechanics extends ActiveObject {

    @resolve(CommandDispatcher) private dispatch!: CommandDispatcher;
    @resolve(ObjectManager) private objects!: ObjectManager;
    @resolve(EditorOptions) private options!: EditorOptions;

    public start(): void {
        const [mode, rule] = (this.options.camera || '').split(':');
        if (mode !== 'auto') return;

        this.scheduler.timeout('openComments', 500, () => {

            const comment = this.objects.getMaybe(rule, Comment);
            if (!comment?.parent) return;

            this.dispatch(commentsOpen, [comment.parent.id, true]);
        });
    }
}
